import { Component, OnInit } from '@angular/core';
import {AppService} from '../app.service';
import {LocalStorageService, SessionStorageService} from 'angular-web-storage';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-installed',
  templateUrl: './installed.component.html',
  styleUrls: ['./installed.component.scss']
})
export class InstalledComponent implements OnInit {

  userCredential: any;
  accessPrivileges: any;
  installedApps: any;

  constructor(
    private _appService: AppService,
    private sessionStorage: SessionStorageService,
    private localStorage: LocalStorageService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {

    this.spinner.show();
    this.userCredential = this.localStorage.get('sociaKey');

    let userEmail = '';
    const userIdentifier = window.navigator.userAgent.replace(/\D+/g, '');

    if (this.userCredential) {
      userEmail = this.userCredential.userEmail;
    }

    this._appService.getUserInstalledApps(userEmail, userIdentifier).subscribe(res => {
      this.installedApps = res;
      this.spinner.hide();
    });

  }

}
